export type IntegrationStatus = 'not_yet' | 'done' | 'not_required';

export function isAccountIntegrated(
  integrationStatus: IntegrationStatus | null,
): boolean {
  return integrationStatus === 'done' || integrationStatus === 'not_required';
}
